
import http from '../components/http';
import { IPedido } from '../interfaces/pedido.interface';

// Função para buscar todos os pedidos
export const fetchPedidos = async (): Promise<IPedido[]> => {
  const response = await http.get('/pedidos');
  return response.data;
};

// Função para criar um novo pedido
export const createPedido = async (pedido: IPedido): Promise<IPedido> => {
  let response;
  try {
    response = await http.post('/pedidos', pedido);
  } catch (error) {
    console.log(error);
  }
  
  return response?.data;
};

// Função para atualizar um pedido existente
export const updatePedido = async (id: string, pedido: IPedido): Promise<IPedido> => {
  const response = await http.put(`/pedidos/${id}`, pedido);
  return response.data;
};

// Função para deletar um pedido
export const deletePedido = async (id: string): Promise<void> => {
  await http.delete(`/pedidos/${id}`);
};
